import { auditCollectorPiletModals } from '@sharefiledev/audit-collector-pilet-sdk';
import type { PiletApi } from '@sharefiledev/sharefile-appshell';
import { addBlocks } from './blocks';
import { configureAuditCollectorHttp } from './common/auditCollectorHttp';
import { addBlockDevelopment } from './development';
import { AsyncCreateActivityReportModal } from './modals';
import { getDefaultCreateActivityReportModalOptions } from './modals/getDefaultModalOptions';

const smokeTestCustomers = [
	'pilet-tests.sharefiletest.com',
	'pilet-tests.sharefilestaging.com',
	'pilet-tests.sharefile.com',
];

export function setup(piral: PiletApi) {
	addBlocks(piral);

	piral.registerModal(
		auditCollectorPiletModals.createActivityReportModal,
		({ options, cancelInteraction, completeInteraction }) => (
			<AsyncCreateActivityReportModal
				piral={piral}
				completeInteraction={completeInteraction}
				cancelInteraction={cancelInteraction}
				{...options!}
			/>
		),
		getDefaultCreateActivityReportModalOptions()
	);

	if (
		process.env.NODE_ENV === 'development' ||
		smokeTestCustomers.includes(location.hostname)
	) {
		addBlockDevelopment(piral);

		if (
			process.env.NODE_ENV === 'development' &&
			typeof piral.meta.config.apiOrigin === 'string'
		) {
			configureAuditCollectorHttp(config => {
				config.origin = piral.meta.config.apiOrigin + '/io/auditcollectorservice/v1';
			});
		}
	}
}
